export const SCENE7_IMAGE_BACKGROUND_DEFAULT = "$product_default_bg$";
export const SCENE7_IMAGE_BACKGROUND_TRANSPARENT_THUMBNAIL =
    "$transparent_thumbnail$";
export const SCENE7_MAX_WIDTH = 1536;
export const SCENE7_MAX_HEIGHT = 2048;
